export default __webpack_public_path__ + "static/media/SD-ganapathi-homam-iframe-img.26e14dd1.png";